const JoinBlog = () => {
	const checkNow = ()=>{
		window.open("https://vikramshilaedu.in/GyanKosh/");
	  }
	return (
		<div className='box-content box-with-small-content-center'>
			<div className='box-inner'>
				<h2 className='large-title tagh2 mb-3'>
					Join The Must-Read Academic Blog For{" "}
					<p>Researchers And PhD Student’s</p>
				</h2>
				<p className='pera-text text-center m-0 tagp'>
					It’s a great way to pick up chatter about what’s brewing in
					scholarly publishing.
				</p>
				<p className='pera-text text-center tagp mb-3'>
					Check out more information about Peer Reviewing on our blog.
				</p>
				<div className='register-button mt-3'>
				<button className="tagbutton" onClick={checkNow}>Check now</button>
				</div>
			</div>
		</div>
	);
};

export default JoinBlog;
